import http from '../jslibs/axios/http';

export const getCategoryList = data => http.get('/cms/FileClass', data);
export const addCategoryList = data => http.post('/cms/FileClass', data);
export const editCategoryList = data => http.put(`/cms/FileClass/${data.uuid}`, data);
export const deleteCategoryList = uuid => http.delete(`/cms/FileClass/${uuid}`);